import { useRouter } from "next/navigation";
import type { JSX } from "react";
import { useSelector } from "react-redux";
import { Divider } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import ExpandTitle from "@/components/atoms/expander/expand-title";
import { RootState } from "@/store/root-reducer";

interface Props {
  brand: "staysure" | "avanti";
  contactTitle?: string | null;
  organizerTitle?: string | null;
  contactBtn?: string;
  editOrganizerBtn?: string | null;
  isOpen: boolean;
  onToggle: () => void;
}
function EditContactDetails({
  contactTitle = "View or edit Contact details",
  contactBtn = "Edit contact details",
  organizerTitle = "Organiser details",
  editOrganizerBtn = "Edit organizer details",
  isOpen,
  onToggle,
  brand,
}: Readonly<Props>): JSX.Element {
  const router = useRouter();
  const { current } = useWizard();

  const { attributes } = useSelector((state: RootState) => state.quote);

  const organizer = attributes.organiser;

  const renderBtn = (onClickMethod: () => void, lable: string) => {
    return (
      <div className="flex">
        <LabelButtonWrapper
          hierarchy="tertiary"
          label={lable}
          className="text-[16px] font-sub-section-header-font font-[600]
          !px-0 leading-[16px] h-[17px]"
          onClick={onClickMethod}
        />
      </div>
    );
  };

  const handleEditBtn = () => {
    router.push(current.edges.contactDetailsEdit ?? "");
  };
  const handleEditOrganizer = () => {
    router.push(current.edges.organiserEdit ?? "");
  };

  return (
    <div data-testid="edit-contact-details">
      <ExpandTitle
        title={contactTitle}
        setIsShow={onToggle}
        initShow={isOpen}
        id="edit-quote-contact-toggle"
        brand={brand}
      />
      {isOpen && (
        <div className="flex flex-col">
          <div className="text-surface-neutral-option-10 font-sub-section-header-font sm:font-semibold md:font-bold sm:text-[16px] md:text-[18px] sm:mt-spacing-xxs md:mt-0">
            {organizer?.email}
            <Divider thickness={1} className="!my-spacing-s" brand={brand} />
            {organizer?.telephone}
          </div>
          <div
            className="sm:mt-spacing-m sm:mb-spacing-s md:my-spacing-m font-semibold"
            id="edit-quote-contact-details"
          >
            {renderBtn(handleEditBtn, contactBtn)}
          </div>
          {!organizer?.travelling && (
            <div>
              <h2 className="text-text-title font-dmserif font-header-font sm:mt-spacing-s sm:mb-spacing-s md:my-spacing-m sm:text-[20px] lg:text-l md:text-header-font-size-medium sm:leading-custom-size-sm md:leading-custom-size-md lg:leading-custom-size-xxl font-sub-section-header-font">
                {organizerTitle}
              </h2>
              <div className="text-surface-neutral-option-10 font-sub-section-header-font sm:font-semibold md:font-bold sm:text-[16px] md:text-[18px] sm:mt-spacing-xxs md:mt-0">
                {organizer?.firstName} {organizer?.lastName}
                <Divider
                  thickness={1}
                  className="!my-spacing-s"
                  brand={brand}
                />
                {organizer?.telephone}
              </div>
              <div
                className="md:my-spacing-m sm:mt-spacing-m sm:mb-spacing-s font-semibold"
                id="edit-quote-organiser-details"
              >
                {renderBtn(handleEditOrganizer, editOrganizerBtn ?? "")}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default EditContactDetails;
